(() => {
  if (customElements.get('kpt-announcement')) return;
  class KptAnnouncement extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
      this.manualPaused = false;
      this.hovered = false;
      this.focused = false;
      this.editorSelected = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.change(-1), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.change(1), options);
      this.querySelector('[data-pause]')?.addEventListener('click', () => {
        this.manualPaused = !this.manualPaused;
        const button = this.querySelector('[data-pause]');
        button.setAttribute('aria-pressed', String(this.manualPaused));
        button.setAttribute('aria-label', this.manualPaused ? button.dataset.playLabel : button.dataset.pauseLabel);
        this.schedule();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = this.dataset.pauseHover === 'true'; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.change(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.editorSelected = true;
        this.show(index);
      }, options);
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.contains(event.target)) return;
        this.editorSelected = false;
        this.schedule();
      }, options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.show(this.index);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
    change(direction) {
      this.show((this.index + direction + this.slides.length) % this.slides.length);
    }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, position) => { slide.hidden = position !== index; });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const paused = this.manualPaused || this.hovered || this.focused || this.editorSelected || document.hidden || this.motion.matches;
      this.querySelector('.kpt-ann__viewport')?.setAttribute('aria-live', paused || this.dataset.autoplay !== 'true' ? 'polite' : 'off');
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || paused) return;
      this.timer = setTimeout(() => this.change(1), Math.max(2000, Number(this.dataset.interval) || 4000));
    }
  }
  customElements.define('kpt-announcement', KptAnnouncement);
})();

(() => {
  if (window.__kptNavigationReady) return;
  window.__kptNavigationReady = true;
  function markCurrent(scope = document) {
    const current = window.location.pathname.replace(/\/$/, '') || '/';
    scope.querySelectorAll('header.kpt-header .horizontal-list > li.level0 > menu-item > a[href]').forEach(link => {
      const target = new URL(link.href, window.location.href);
      const path = target.pathname.replace(/\/$/, '') || '/';
      if (target.origin === window.location.origin && path === current) link.setAttribute('aria-current', 'page');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => markCurrent(), { once: true });
  else markCurrent();
  document.addEventListener('shopify:section:load', event => markCurrent(event.target));
})();
